import React from "react";
import "./maps.scss";
import Mapsimage from "../../media/maps.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckDouble } from "@fortawesome/free-solid-svg-icons";

const maps = () => {
  return (
    <div className="container-maps">
      <div className="judul">LOKASI</div>
      <div className="google-maps">
        <img className="maps" src={Mapsimage} alt="maps" />
      </div>
      <div className="feature">
        <div className="feature-list1">
          <div className="penawaranpoin">
            <FontAwesomeIcon icon={faCheckDouble} />
            <span style={{ color: "black" }}>
              &nbsp;&nbsp;10 Menit ke Pakuwon Mall
            </span>
          </div>
          <div className="penawaranpoin">
            <FontAwesomeIcon icon={faCheckDouble} />
            <span style={{ color: "black" }}>&nbsp;&nbsp;2 Menit ke Gwalk</span>
          </div>
          <div className="penawaranpoin">
            <FontAwesomeIcon icon={faCheckDouble} />
            <span style={{ color: "black" }}>
              &nbsp;&nbsp;2 Menit ke Pasar Modern
            </span>
          </div>
          <div className="penawaranpoin">
            <FontAwesomeIcon icon={faCheckDouble} />
            <span style={{ color: "black" }}>
              &nbsp;&nbsp;10 Menit ke UNESA
            </span>
          </div>
        </div>
        <div className="feature-list1">
          <div className="penawaranpoin">
            <FontAwesomeIcon icon={faCheckDouble} />
            <span style={{ color: "black" }}>
              &nbsp;&nbsp;2 Menit ke Citraland Golf
            </span>
          </div>
          <div className="penawaranpoin">
            <FontAwesomeIcon icon={faCheckDouble} />
            <span style={{ color: "black" }}>
              &nbsp;&nbsp;15 Menit ke akses Tol
            </span>
          </div>
          <div className="penawaranpoin">
            <FontAwesomeIcon icon={faCheckDouble} />
            <span style={{ color: "black" }}>
              &nbsp;&nbsp;20 Menit Pakuwon Trade Center (PTC)
            </span>
          </div>
          <div className="penawaranpoin">
            <FontAwesomeIcon icon={faCheckDouble} />
            <span style={{ color: "black" }}>
              &nbsp;&nbsp;5 Menit ke Univ Ciputra
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default maps;
